import { Input, Form, Typography, Image, Card, Button, Select } from "antd";
import Logo from "../../../../assets/images/Logo_250.png";
import { FormInstance } from "antd/lib";
import { CustomerUrlDto } from "../../../../types/customer-url.type";
import { useState } from "react";
import { useParams } from "react-router-dom";

export interface Props {
  onChangeCurrentStep: (step: number) => void;
  currentStep: number;
  stepsLength: number;
  form: FormInstance;
  masterDataEvent: {
    value: string;
    label: string;
  }[];
  submitFormParthner: (data: any) => void;
  customerData: CustomerUrlDto;
}
const EconnectStepThreePartner: React.FC<Props> = ({
  onChangeCurrentStep,
  currentStep,
  stepsLength,
  form,
  masterDataEvent,
  submitFormParthner,
  customerData,
}): React.ReactElement => {
  const { agendaid, typeregis, customerid } = useParams<{ agendaid: string; typeregis: string; customerid: string }>();
  const [valueBusinessType, setValueBusinessType] = useState<string>("");
  const onSelectBusinessType = (value: string) => {
    setValueBusinessType(value);
  };
  return (
    <Card>
      <br />
      <div className="flex justify-center pb-[20px]">
        <Image src={Logo} width={150} preview={false} />
      </div>
      <div className="text-center mt-[5px] pb-[20px]">
        <Typography className="font-bold w-full text-[rgba(84,86,90,1)]">{`Registration Form for check in`}</Typography>
      </div>
      <div>
        <Form form={form} onFinish={submitFormParthner} layout="vertical" autoComplete="off" className="w-full">
          <Form.Item
            className=" m-1"
            label={"Name-Surname"}
            name={"fullName"}
            rules={[
              {
                required: true,
                message: "Please fill in your name surname!",
              },
            ]}
          >
            <Input placeholder="Text" />
          </Form.Item>
          <Form.Item
            className=" m-1"
            label={"Position"}
            name={"position"}
            rules={[
              {
                required: true,
                message: "Please fill in your position!",
              },
            ]}
          >
            <Input placeholder="Text" />
          </Form.Item>
          <Form.Item
            className=" m-1"
            label={"Company"}
            name={"company"}
            rules={[
              {
                required: true,
                message: "Please fill in your Company!",
              },
            ]}
          >
            <Input placeholder="Text" readOnly={typeregis === "vip" ? false : true} />
          </Form.Item>
          <Form.Item
            className=" m-1"
            label={"Business Type"}
            name={"businessType"}
            rules={[
              {
                required: true,
                message: "Please select Business Type!",
              },
            ]}
          >
            <Select placeholder="Select" onChange={onSelectBusinessType} options={masterDataEvent} />
          </Form.Item>
          {valueBusinessType === "13" && (
            <Form.Item
              className=" m-1"
              label={"Other"}
              name={"otherText"}
              rules={[
                {
                  required: true,
                  message: "Please fill in your Other!",
                },
              ]}
            >
              <Input placeholder="Text" />
            </Form.Item>
          )}
          <Form.Item
            className=" m-1"
            label={"Business Email"}
            name={"businessEmail"}
            rules={[
              {
                required: true,
                message: "Please fill in your email!",
              },
            ]}
          >
            <Input placeholder="example@email.com" type="email" />
          </Form.Item>

          <Form.Item
            className=" m-1"
            label={"Telephone"}
            name={"phoneNumber"}
            rules={[
              {
                required: true,
                message: "Please fill in your phone!",
              },
            ]}
          >
            <Input placeholder="0XX-XXX-XXXX" />
          </Form.Item>
          <Form.Item>
            <div className="flex justify-center items-center w-full pt-8">
              <div>
                {currentStep < stepsLength - 1 && currentStep === 2 && (
                  <div className="w-[300px]">
                    <Button htmlType="submit" type="primary" className="text-white bg-[rgba(10,78,136,1)] w-full rounded-[5px]" size="large">
                      Confirm
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </Form.Item>
        </Form>
      </div>
    </Card>
  );
};
export default EconnectStepThreePartner;
